export default __webpack_public_path__ + "static/media/screeen.5c0e2cdc.png";